import {
  useFirestoreCollectionMutation,
  useFirestoreDocumentMutation,
  useFirestoreQuery,
} from '@react-query-firebase/firestore';
import { collection, doc, getDocs } from 'firebase/firestore';

import { firestore } from '../Firebase';

import { getQuery } from './firestore';

export const editColoringGridCollection = (id: string) => {
  const ref = doc(collection(firestore, 'coloringGridCollections'), id);
  return useFirestoreDocumentMutation(ref, { merge: true });
};

export const addColoringGridCollection = () => {
  const collectionRef = collection(firestore, 'coloringGridCollections');
  return useFirestoreCollectionMutation(collectionRef);
};
export const getAllColoringGridCollections = () => {
  const ref = collection(firestore, 'coloringGridCollections');
  return useFirestoreQuery(['coloringGridCollections'], ref, {
    subscribe: true,
  });
};

/**
 * Checks if collection is empty.
 * Optimizes by limiting query to 1 puzzle.
 *
 * @param collectionId
 */
export const isColoringGridCollectionEmpty = async (collectionId: string) => {
  const minimalCollecionPuzzlesQuery = getQuery({
    collectionPath: 'coloringGrids',
    filters: [
      {
        attribute: 'collections',
        operator: 'array-contains',
        value: collectionId,
      },
    ],
    limit: 1,
  });

  // This version of Firebase SDK doesn't have getCountFromServer, we should consider upgrading.
  const querySnapshot = await getDocs(minimalCollecionPuzzlesQuery);
  return querySnapshot.empty;
};
